<template>
  <v-flex mb-2 xs12>
    <div v-if='mode == "finished"'>
        Complete
    </div>
    <div v-if='mode == "error"'>
        <v-alert :value="true" type="error" >
            {{error_message}}
        </v-alert>
    </div>
    <div v-if='mode == "confirm"' style='background: #ccc'>
        <b>Is this the right person?</b>
        <br/>
        {{ attendee.full_name }} / {{ attendee.native_name }} / {{ attendee.nickname }}
        <br/>

        <v-alert
          :value="true"
          type="info"
            v-if="!attendee.active" 
        >
           Remove Member From Room?
        </v-alert>

        <v-btn xs4 color='success' @click="confirm">Remove Member</v-btn>
        <v-btn xs4 color='error' @click="cancel_confirm">Cancel</v-btn>
    </div>
    <div v-if='mode == "lookup"'>
        Remove Member
        <v-form ref="form">
          <v-layout row wrap  justify-center>
            <v-flex xs6 sm6 md3>
              <v-select
                :items="items"
                v-model="attendee_id"
                label="Select Member"
                @change="changed"
                outline
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs6 sm6 md3>
              <v-btn color="primary" @click="lookup">Remove Member</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
    </div>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex';
import {fetcher} from '@/fetcher';

export default {
  props: ['room_allocation', 'attendees'],
  data: () => ({
    mode: 'lookup',
    event: {},
    ready: false,
    attendee: {},
    attendee_id: undefined,
    code_error_messages: [],
    error_message: '',
    finished: false,
  }),
  beforeMount: async function() {},
  computed: {
    ...mapState(['myprofile', 'events']),
    items() {
      return this.attendees.map(a => {
        return {
          text: `${a.full_name} / ${a.native_name} / ${a.nickname}`,
          value: a.id,
        };
      });
    },
  },
  watch: {},
  methods: {
    changed() {
      console.log('rdm', 'changed');
    },
    lookup() {
      if (!!this.$data.attendee_id) {
        this.$data.attendee = this.attendees.find(
          a => a.id == this.$data.attendee_id,
        );
        if (!!this.$data.attendee) {
          this.$data.mode = 'confirm';
        }
      }
    },
    cancel_confirm() {
      this.$data.mode = 'lookup';
      this.$data.attendee_id = undefined;
      this.$data.attendee = {};
    },
    confirm() {
      var that = this;
      fetcher
        .delete('/myprofile/room_allocation_del_attendee', {
          data: {
            event_id: this.$route.params.event_id,
            room_allocation_id: this.room_allocation.id,
            attendee_id: this.$data.attendee.id,
          },
        })
        .then(res => {
          if (res.data.success) {
            this.$data.mode = 'finished';
            that.$store.dispatch('loadEventTeams', {
              event_id: this.$route.params.event_id,
            });
            setTimeout(() => {
              this.$data.mode = 'lookup';
            }, 1000);
          } else {
            this.$data.error_message = res.data.message;
            this.$data.mode = 'error';
            setTimeout(() => {
              this.$data.mode = 'lookup';
            }, 2000);
          }
        });
    },
  },
};
</script>

<style>
.event_profile_code {
  font-size: 3em;
  border: 1px solid black;
}
.display_upcase input {
  text-transform: uppercase;
}
</style>
